<template>
  <div class="fairUseCountdown">
    <div
      :class="['daysLeft', status]"
      :data-test-id="$testId('daysLeft')"
    >
      <MarkdownInline
        :data-test-id="$testId('remainingDaysCopy')"
        :mdTemplate="fairUseCountdownCopy"
      />
    </div>
    <div class="trialDates">
      <div
        class="trialDetails"
        :data-test-id="$testId('startDate')"
      >
        Trial Start Date:
        <span class="date">{{ startDate.format('MM/DD/YYYY') }}</span>
      </div>
      <div
        class="trialDetails"
        :data-test-id="$testId('endDate')"
      >
        Fair Use End Date:
        <span class="date">{{ endDate.format('MM/DD/YYYY') }}</span>
      </div>
      <div
        class="fairUsePolicyLearnMore"
      >
        <span>Learn more about our </span>
        <Link
          :data-test-id="$testId('fairUsePolicyLink')"
          :href="fairUsePolicyLink.url"
          target="_blank"
          text="fair use policy"
          @click.native="handleFairUsePolicyLinkClick"
        />.
      </div>
    </div>
  </div>
</template>

<script>
import { Link, MarkdownInline } from '@jumpcloud/ui-components';
import { UiEvents } from '@jumpcloud/ui-events-vue';
import moment from 'moment';
import pluralize from 'pluralize';

import { trialModalLinks } from 'client/util/Constants/FeatureTrialConstants';

export default {
  name: 'FairUseCountdown',

  components: {
    Link,
    MarkdownInline,
  },

  props: {
    endDate: {
      type: Object,
      default: () => {},
    },
    featureName: {
      type: String,
      default: () => '',
    },
    startDate: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    adverb() {
      let adverb = 'in';

      if (this.remainingDays < 0) {
        adverb = 'past';
      } else if (this.remainingDays > 0) {
        adverb = 'left';
      }

      return adverb;
    },

    daysLeft() {
      return `${this.remainingDaysCopy} ${this.adverb}`;
    },

    fairUseCountdownCopy() {
      const preposition = this.remainingDays > 0 ? ' in ' : ' ';

      return `${this.subject} **${this.daysLeft}**${preposition}the fair use period.`;
    },

    remainingDays() {
      return moment(this.endDate).endOf('day').diff(moment().endOf('day'), 'days');
    },

    remainingDaysCopy() {
      return `${Math.abs(this.remainingDays)} ${pluralize('day', this.remainingDays)}`;
    },

    status() {
      let status = '';

      if (this.remainingDays < 0) {
        status = 'error';
      } else if (this.remainingDays <= 15 && this.remainingDays >= 0) {
        status = 'warning';
      }

      return status;
    },

    subject() {
      let subject = 'There are';

      if (this.remainingDays < 0) {
        subject = 'You are';
      } else if (this.remainingDays <= 15) {
        subject = 'You have';
      }

      return subject;
    },
  },

  created() {
    this.fairUsePolicyLink = trialModalLinks.fairUsePolicy;
  },

  methods: {
    handleFairUsePolicyLinkClick() {
      UiEvents.triggerLinkClicked({
        description: 'fair use policy link click',
        text: 'fair use policy',
        page: `${this.featureName} Trial Modal`,
        section: 'fair use countdown',
        toUrl: this.fairUsePolicyLink.url,
      });
    },
  },
};
</script>

<style scoped>
.daysLeft.warning /deep/ span strong {
  color: var(--jcWarning);
}

.daysLeft.error /deep/ span strong {
  color: var(--jcError);
}

.fairUseCountdown {
  font-size: var(--jcBodyLarge);
}

.fairUsePolicyLearnMore {
  font-size: var(--jcBodyTiny);
  font-style: italic;
  margin-top: var(--jc-spacer-small);
}

.countDownText {
  font-weight: bold;
}

.trialDates {
  display: inline-block;
  font-size: var(--jcBodyLarge);
  margin-top: var(--jc-spacer);
}

.trialDates .trialDetails {
  font-size: var(--jcBodyLarge);
  margin: 0 auto;
  margin-top: var(--jc-spacer-small);
  text-align: left;
}

.trialDates .trialDetails .date {
  font-weight: bold;
}
</style>
